module.exports = __webpack_public_path__ + "static/media/doc_svg.d11ec3de.svg";